import {Injectable} from '@angular/core';
import {BaseApiService} from '../../shared/base-service/base-api.service';
import {OrganizationDetailViewModel} from '../models/views/organization-detail-view.model';

@Injectable()
export class OrganizationDetailService extends BaseApiService {
    getData(customerId: string) {
        return this.get('Customer/' + customerId);
    }

    setPreferredContactMethod(organizationDetails: OrganizationDetailViewModel) {

        // Set Preferred Mailing Contact
        var preferredContact = organizationDetails.contacts.find(c => c.isPreferredContactMethod);
        if (!preferredContact) {
            if (organizationDetails.mailingAddress.isSameAsPhysical) {
                organizationDetails.physicalAddress.isPreferredContactMethod = true;
            } else {
                organizationDetails.mailingAddress.isPreferredContactMethod = true;
            }
        }

    }
}
